<template>
  <div>
    <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Recarga</b-card-header>
      <b-card-body>
        <form-wizard ref="wizard" :hide-buttons="true" title subtitle>
         
          <tab-content title="Producto" icon="fa fa-mobile-alt" :before-change="validateArticulo">
            <div class="row form-group">
              <div class="col-md-12">
                <div class="col-md-12">
                  <div class="row" style="background-color: white;">
                    <div
                      v-for="item in articulos"
                      @click="itemClicked(item)"
                      v-bind:key="item.id"
                      :value="item.id"
                      class="col-md-6 col-sm-6"
                      style="padding: 5px; cursor: pointer; margin-right: 0; margin-left: 0"
                    >
                      <div class="text-center">
                        <img :src="item.image" style="width: 50px" :alt="item.Name" />
                      </div>
                      <div class="text-center">{{item.Name}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-content>
          <tab-content title="Datos" icon="fa fa-address-card">
          <div class="text-center" style="background-color: white;">
              <div style="padding: 5px; cursor: pointer;">
                  <div class="text-center">
                      <img :src="articuloSelected.image" style="width: 100px" :alt="articuloSelected.name" />
                  </div>
                  <div class="text-center">{{articuloSelected.name}}</div>
              </div>
           </div>

            <CelularFormType v-if="formType==1" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <GDTFormType v-if="formType==2" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <DTVFormType v-if="formType==3" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <SubeFormType v-if="formType==5" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <SPKFormType v-if="formType==8" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <ABCGolFormType v-if="formType==7" v-model="model" :model="modelProp"></ABCGolFormType>
            <EdenorFormType v-if="formType==9" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <HipodromoFormType v-if="formType==14" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"/>
            <AntinaFormType v-if="formType==11" v-model="model" :model="model" v-on:saldoOK="onSaldoOK"></AntinaFormType>

            <div class="row text-right" style="margin-top:10px">
              <div class="col-md-12">
                <save-button text="Recargar" @click="onRealizarRecarga" :disabled="btnRecargarDisabled"/>
              </div>
            </div>
          </tab-content>

           <!-- Resultado de la Recarga -->
          <tab-content title="Resultado" icon="fa fa-fw fa-flag">
            <div class="row">
              <div class="col-md-12">
                <base-alert :type="resultado.Tipo">
                  <span class="alert-inner--icon">
                    <i :class="resultado.Icono"></i>
                  </span>
                  <span class="alert-inner--text" v-html="resultado.Texto"></span>
                </base-alert>
              </div>
            </div>

            <!-- Si es Edenor, mostrarmos el ticket -->
            <div class="row" v-show="isEdenor">
              <div class="col-md-6 ticketEdenor">
                  <span class="pre-formatted" v-html="ticket.Texto"></span>
              </div>
            </div>

            <!-- Nueva Recarga -->
            <div class="row">
              <div class="col-md-12 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="nuevaRecarga"
                  style="margin: auto; margin-top: 10px"
                >
                  <i class="fa fa-plus fa-fw"></i>Nueva Recarga
                </base-button>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </b-card-body>
    </b-card>
    <pin-validation ref="pin-validation"
      :showModal.sync="showModalPinValidation"
      v-on:validPin="onValidPin"
      v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation>
  </div>
</template>

<style scoped>
.wizard-footer-right button {
  display: none !important;
}

.wizard-footer-left button {
  display: none !important;
}

.pre-formatted {
  white-space: pre;
}

.ticketEdenor{
  border-color: #ff5855;
  border-style:solid;
  border-width:3px;
  max-width:600px;
  margin: auto;
  width: 50%;
  text-align:center;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import { FormWizard, TabContent,WizardStep } from "vue-form-wizard";
import vSelect from "vue-select";

import CelularFormType from "@/components/FormsType/CelularFormType";
import DTVFormType from "@/components/FormsType/DTVFormType";
import GDTFormType from "@/components/FormsType/GDTFormType";
import notificationHelpers from '@/helpers/notificationHelpers';
import SubeFormType from "@/components/FormsType/SubeFormType";
import SPKFormType from "@/components/FormsType/SPKFormType";
import ABCGolFormType from "@/components/FormsType/ABCGolFormType";
import EdenorFormType from "@/components/FormsType/EdenorFormType";
import HipodromoFormType from "@/components/FormsType/HipodromoFormType";
import AntinaFormType from "@/components/FormsType/AntinaFormType";

import "vue-select/dist/vue-select.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

Vue.component("v-select", vSelect);

// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import PinValidation from '@/views/Pin/PinValidation';

export default {
  components: { 
    CelularFormType,
    DTVFormType,
    GDTFormType,
    FormWizard,
    TabContent,
    WizardStep, 
    SubeFormType,
    SPKFormType,
    ABCGolFormType,
    EdenorFormType,
    HipodromoFormType,
    AntinaFormType, 
    "pin-validation": PinValidation
  },
  data() {
    return {
      model: {
        Aux1: "",
        Aux2: "",
        Aux3: "",
        Aux4: "",
        Importe: 0,
        Errors: []
      },
      articulos: [],
      articuloSelected: {image:"",name:""},
      formType: 0,
      saldos: { FormatedAmount: "", FormatedAvailableAmount: "" },
      resultado: { Icono: "", Texto: "", Tipo: "" },
      estados: { Aprobado: 3, Rechazado: 4, Consulta: 5 },
      usePaymentPin: false,
      showModalPinValidation: false,
      isEdenor: false,
      ticket: { Icono: "", Texto: "", Tipo: "" },
      btnRecargarDisabled: false
    };
  },
  methods: {
    async itemClicked(itemSelected) {
      let context = this;

      context.articuloSelected = itemSelected;
      context.btnRecargarDisabled = false;

      this.getFormType();
    },
    cleanSelected() {
      let context = this;
      context.articuloSelected = {image:"",name:""};
    },
    validateArticulo() {
      let context = this;
      return context.articuloSelected != {image:"",name:""};
    },
    nuevaRecarga() {
      this.model = {
        Aux1: "",
        Aux2: "",
        Aux3: "",
        Aux4: "",
        Importe: 0,
        Errors: []
      };
      this.isEdenor = false;
      // this.$refs.wizard.reset();
      this.$router.go()


    },
    onRealizarRecarga() {
      this.validate();
    },
    validate() {
      let context = this;

      if (!context.model.Validate) {
        if(context.model.Errors.length>0) {
          context.model.Errors.forEach(element => {
            notificationHelpers.showError("Error",element,this);
          });
        } else {
          notificationHelpers.showError("Error","Debe completar todos los campos",this);
        }
        return;
      } 

      this.pinValidate();
    },
    realizarRecarga() {
      let context = this;
    
      let req = {
        Aux1: context.model.Aux1,
        Aux2: context.model.Aux2,
        Aux3: context.model.Aux3,
        Aux4: context.model.Aux4,
        ArticleID: context.articuloSelected.id,
        Amount: context.model.Importe,
        IsAndroid: false,
        DeviceID: ""
      };

      axiosHelpers.axiosPost("Recarga/InsertAndWaitResult", req, this, function(
        data
      ) {
        if (data.Alerts.length == 0) {
          if (data.ResponseVM.TransactionStateID == context.estados.Aprobado) {
            
            // Si no tiene nro de transaccion (caso Hipodromo) no mostramos "Número de transacción:"
            let nroTranLine = data.ResponseVM.TransactionNumber.length != 0 ? " Número de transacción: " +
              data.ResponseVM.TransactionNumber +
              "<br/>" : "";

            let msg =
              "La recarga se realizó satisfactoriamente" +
              "<br/>" +
              " Número de operación: " +
              data.ResponseVM.QueueID +
              "<br/>" +
              " Número de comprobante: " +
              data.ResponseVM.FormatedReceiptID +
              "<br/>" +
              nroTranLine;

            context.resultado = {
              Texto: msg,
              Tipo: "success",
              Icono: "fa fa-fw fa-thumbs-up"
            };

            if(context.articuloSelected.id == context.$store.getters.EdenorArticleID)
            {
              context.isEdenor = true;

              let msgTicket = 
                 "Ticket de la Recarga:" +
                 "<br/>" +
                 data.ResponseVM.Ticket;

              context.ticket = {
                Texto: msgTicket,
                Tipo: "success",
                Icono: "fa fa-fw fa-thumbs-up"
              };
            }
            context.$refs.wizard.nextTab();
          } else if (
            data.ResponseVM.TransactionStateID == context.estados.Rechazado ||
            data.ResponseVM.TransactionStateID == context.estados.Consulta
          ) {
            context.resultado = {
              Texto: data.ResponseVM.ErrorMsg,
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down"
            };
            context.$refs.wizard.nextTab();
          } else {
            context.resultado = {
              Texto:
                "La operación esta demorando mas de lo normal, te avisaremos cuando este el resultado final de la operación",
              Tipo: "warning",
              Icono: "fa fa-fw fa-clock"
            };
            context.$refs.wizard.nextTab();
          }
        } else {
          context.resultado = {
            Texto: data.Alerts[0].Message,
            Tipo: "danger",
            Icono: "fa fa-fw fa-thumbs-down"
          };
          context.$refs.wizard.nextTab();
        }
      });
    },
     getFormType() {
      let context = this;
      var param = { articleID: context.articuloSelected.id };
      axiosHelpers.axiosGet(
        "Article/GetFormTypeIDByArticle",
        param,
        context,
        function(data) {
          context.formType = data.ResponseVM.FormTypeID;

        context.model = {
        Aux1: "",
        Aux2: "",
        Aux3: "",
        Aux4: "",
        Importe: 0,
        Errors: [],
        Validated:false,
      };

          context.$refs.wizard.nextTab();
        }
      );
    },
    async cargarSaldos(context) {
      axiosHelpers.axiosGet(
        "Supplier/AddSupplierTransferGet",
        {},
        context,
        function(data) {
          context.saldos = data.ResponseVM;
        }
      );
    },
    async cargarArticulos(context) {
      axiosHelpers.axiosGet("Article/GetForRecarga", {}, context, function(
        data
      ) {
        context.articulos = data.ResponseVM;
      });
    },
    onValidPin(val) {
      if(val) {
        this.realizarRecarga();
      }
    },
    onLoadUsePaymentPin(val) {
      this.usePaymentPin = val;
    },
    pinValidate() {
      if(this.usePaymentPin) {
        this.showModalPinValidation = true;
      } else {
        this.realizarRecarga();
      }
    },
    onSaldoOK(val) {
      this.btnRecargarDisabled = !val;
    }
  },
  beforeMount: function() {
    let context = this;
    this.cargarSaldos(this);
    this.cargarArticulos(this);
  }
};
</script>